import styles from '../styles/TransparentAndVerified.module.css';

const TransparentAndVerified: React.FC = () => {
  return (
    <div className={styles.transparentAndVerified}>
      <div>
        <svg
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4.39507 9.5002C4.18719 9.49953 3.98892 9.41262 3.84757 9.2602L0.202566 5.3827C-0.0811699 5.08032 -0.0660595 4.60518 0.236316 4.32145C0.538692 4.03771 1.01383 4.05282 1.29757 4.3552L4.38757 7.6477L10.6951 0.747698C10.8695 0.530509 11.1499 0.427874 11.4233 0.481154C11.6967 0.534435 11.9181 0.734854 11.9982 1.00164C12.0783 1.26843 12.0039 1.55763 11.8051 1.7527L4.95007 9.2527C4.81003 9.40789 4.61158 9.4976 4.40257 9.5002H4.39507Z" />
        </svg>
        <p>100% Transparent contribution</p>
      </div>

      <div>
        <svg
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4.39507 9.5002C4.18719 9.49953 3.98892 9.41262 3.84757 9.2602L0.202566 5.3827C-0.0811699 5.08032 -0.0660595 4.60518 0.236316 4.32145C0.538692 4.03771 1.01383 4.05282 1.29757 4.3552L4.38757 7.6477L10.6951 0.747698C10.8695 0.530509 11.1499 0.427874 11.4233 0.481154C11.6967 0.534435 11.9181 0.734854 11.9982 1.00164C12.0783 1.26843 12.0039 1.55763 11.8051 1.7527L4.95007 9.2527C4.81003 9.40789 4.61158 9.4976 4.40257 9.5002H4.39507Z" />
        </svg>
        <p>Third party verified projects</p>
      </div>
    </div>
  );
};

export default TransparentAndVerified;
